import { render, staticRenderFns } from "./PgaUsersTableIndex.vue?vue&type=template&id=5548cbb8&"
import script from "./PgaUsersTableIndex.vue?vue&type=script&lang=ts&"
export * from "./PgaUsersTableIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5548cbb8')) {
      api.createRecord('5548cbb8', component.options)
    } else {
      api.reload('5548cbb8', component.options)
    }
    module.hot.accept("./PgaUsersTableIndex.vue?vue&type=template&id=5548cbb8&", function () {
      api.rerender('5548cbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Provisioning/Users/Components/PgaUsersTableIndex.vue"
export default component.exports